import Error from '../common/errorData'
import CON from '../constant'
import {
  http
} from './index'
const pasurl = CON.URL_DOWN
const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}

const postReq = (url, data) => { // 封装post参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
  listAllMainLeader: (data) => getReq('/ndata/pc/mainleader/listAll', data).then(Error),
  login: (data) => postReq('/ndata/login', data).then(Error),
  logout: (data) => getReq('/ndata/login/logout', data).then(Error)
}



// WEBPACK FOOTER //
// ./src/apis/leader.js